
import React, { useState } from 'react';
import hicon from '../../images/icon/magic.svg'
import { Fade } from "react-awesome-reveal";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';

const FaqSection = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className="faq pb-140">
            <div className="container">
                <div className="sec-title--two text-center mb-60">
                    <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                        <div>
                            <div className="sub-title wow fadeInDown" data-wow-duration="600ms">
                                <img src={hicon} alt="" />Enterprise Technology FAQs
                            </div>
                        </div>
                    </Fade>
                    <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                        <div>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">
                                Strategic Technology Insights
                            </h2>
                        </div>
                    </Fade>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="xb-faq wow fadeInUp" data-wow-delay="200ms" data-wow-duration="600ms">
                            <Accordion open={open} toggle={toggle} className='accordion_box clearfix list-unstyled'>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="1" className='acc-btn'>
                                        <span className="number">01</span> . What is your approach to enterprise digital transformation?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="1" className='acc_body'>
                                        <div className="content">
                                            <p>Our 360° transformation framework delivers measurable results within 6-9 months through:</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Cloud-native architecture design</li>
                                                <li><i className="far fa-check"></i>AI/ML integration roadmaps</li>
                                                <li><i className="far fa-check"></i>Legacy system modernization strategies</li>
                                                <li><i className="far fa-check"></i>Continuous security integration</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>

                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="2" className='acc-btn'>
                                        <span className="number">02</span> . How do you ensure solution scalability?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="2" className='acc_body'>
                                        <div className="content">
                                            <p>Our architectures are built for enterprise growth with:</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Microservices-based design</li>
                                                <li><i className="far fa-check"></i>Auto-scaling cloud infrastructure</li>
                                                <li><i className="far fa-check"></i>Containerized deployment pipelines</li>
                                                <li><i className="far fa-check"></i>Multi-cloud redundancy planning</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>

                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="3" className='acc-btn'>
                                        <span className="number">03</span> . What security frameworks do you implement?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="3" className='acc_body'>
                                        <div className="content">
                                            <p>Enterprise-grade protection through:</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Zero Trust architecture design</li>
                                                <li><i className="far fa-check"></i>SOC 2 Type II compliance</li>
                                                <li><i className="far fa-check"></i>Real-time threat detection systems</li>
                                                <li><i className="far fa-check"></i>End-to-end data encryption</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>

                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="4" className='acc-btn'>
                                        <span className="number">04</span> . Can you integrate with existing IT ecosystems?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="4" className='acc_body'>
                                        <div className="content">
                                            <p>Seamless interoperability achieved via:</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>API-first development approach</li>
                                                <li><i className="far fa-check"></i>Enterprise Service Bus integration</li>
                                                <li><i className="far fa-check"></i>Legacy system modernization</li>
                                                <li><i className="far fa-check"></i>Continuous integration pipelines</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>

                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="5" className='acc-btn'>
                                        <span className="number">05</span> . What ongoing support do you provide?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="5" className='acc_body'>
                                        <div className="content">
                                            <p>24/7 enterprise support including:</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Managed cloud services</li>
                                                <li><i className="far fa-check"></i>Predictive maintenance AI</li>
                                                <li><i className="far fa-check"></i>SLA-backed performance guarantees</li>
                                                <li><i className="far fa-check"></i>Quarterly optimization reviews</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};
export default FaqSection;
